import { FC } from 'react';
import { FieldErrors } from 'react-hook-form';
import { Box } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';
import { ErrorSummary } from '@digdir/designsystemet-react';

import { State } from './types';

interface ErrorMessageProps {
  errors: FieldErrors<State>;
}

export const ErrorMessage: FC<ErrorMessageProps> = ({ errors }) => {
  const { t } = useTranslation();

  if (Object.keys(errors).length === 0) {
    return null;
  }

  return (
    <Box mt={10}>
      <ErrorSummary>
        <ErrorSummary.Heading>{t("register.errorMessage.description")}</ErrorSummary.Heading>
        <ErrorSummary.List aria-label={t('register.errorMessage.list')}>
          {Object.entries(errors).map(([field, error]) => {
            return (
              <ErrorSummary.Item key={field} aria-label={error.message}>
                {t(error.message as string)}
              </ErrorSummary.Item>
            );
          })}
        </ErrorSummary.List>
      </ErrorSummary>
    </Box>
  );
};
